export default __webpack_public_path__ + "static/char-thumb-30-8da189f43876eaf5386ef094b0b04c53.webp";